import { RootState } from '@/shared/store'

import { planningInboxRowsAdapter } from '../adapters/planningInboxRowsAdapter'

export const planningInboxRowsSelector = planningInboxRowsAdapter.getSelectors<RootState>(
  (state) => state.planningInboxRows,
)
